<template>
  <div class="content">
    <table class="table" slot="content">
      <tbody>
      <tr>
        <td><strong>Cím</strong></td>
        <td>{{ bestPractice.fields.dataSheet.fields.title }}</td>
      </tr>
      <tr>
        <td><strong>Azonosítószám</strong></td>
        <td>{{ bestPractice.fields.dataSheet.fields.identifier }}</td>
      </tr>
      <tr>
        <td>Kiadás dátuma</td>
        <td>{{ bestPractice.fields.dataSheet.fields.publicationDateText }}</td>
      </tr>
      <tr>
        <td>Érvényesség dátuma</td>
        <td>{{ bestPractice.fields.dataSheet.fields.validityDateText }}</td>
      </tr>
      <tr>
        <td>Beküldő intézmény neve, címe</td>
        <td>{{ bestPractice.fields.dataSheet.fields.submittedByInstituteName }}</td>
      </tr>
      <tr>
        <td>Szerző(k) neve, beosztása</td>
        <td>
        <span
          v-for="author in bestPractice.fields.dataSheet.fields.authors"
          :key="author"
        >{{ author }}<br></span>
        </td>
      </tr>
      <tr>
        <td>Kapcsolatfelvétel</td>
        <td>
        <span
          v-for="contact in bestPractice.fields.dataSheet.fields.contacts"
          :key="contact"
        >{{ contact }}<br></span>
        </td>
      </tr>
      <tr>
        <td>Lektoráltá(k)</td>
        <td>
        <span
          v-for="proofreader in bestPractice.fields.dataSheet.fields.proofreaders"
          :key="proofreader"
        >{{ proofreader }}<br></span>
        </td>
      </tr>
      <tr>
        <td>Érintett betegbiztonsági témakör</td>
        <td>{{ bestPractice.fields.dataSheet.fields.topic }}</td>
      </tr>
      <tr>
        <td>Jógyakorlat alkalmazásának kezdete</td>
        <td>{{ bestPractice.fields.dataSheet.fields.applicationDateText }}</td>
      </tr>
      <tr>
        <td>Érintett szakterületek</td>
        <td class="dynamic-double-column"><markdown>{{ bestPractice.fields.dataSheet.fields.areasOfExpertise }}</markdown></td>
      </tr>
      <tr>
        <td>Érintett ellátási formák</td>
        <td>
        <span
          v-for="affectedCareType in bestPractice.fields.dataSheet.fields.affectedCareTypes"
          :key="affectedCareType"
        >{{ affectedCareType }}<br></span>
        </td>
      </tr>
      <tr>
        <td>Érintett munkakörök</td>
        <td>
          <span
                v-for="affectedJobType in bestPractice.fields.dataSheet.fields.affectedJobTypes"
                :key="affectedJobType"
          >{{ affectedJobType }}</span>
        </td>
      </tr>
      <tr>
        <td>Érintett beteg / klienscsoportok</td>
        <td>
          <span
                v-for="affectedPatientType in bestPractice.fields.dataSheet.fields.affectedPatientTypes"
                :key="affectedPatientType"
          >{{ affectedPatientType }}</span>
        </td>
      </tr>
      <tr>
        <td>Tárgyi eszköz igényesség</td>
        <td><markdown>{{ bestPractice.fields.dataSheet.fields.deviceRequirements }}</markdown></td>
      </tr>
      <tr>
        <td>Időigényesség</td>
        <td><markdown>{{ bestPractice.fields.dataSheet.fields.timeRequirement }}</markdown></td>
      </tr>
      <tr>
        <td>Humán erőforrás igényesség</td>
        <td><markdown>{{ bestPractice.fields.dataSheet.fields.humanResourcesRequirement }}</markdown></td>
      </tr>
      <tr>
        <td>Kulcsszavak</td>
        <td>
          <div class="tags">
            <span class="tag is-warning"
                  v-for="keyword in bestPractice.fields.dataSheet.fields.keywords"
                  :key="keyword"
            >{{ keyword }}</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: [
      'bestPractice'
    ],
    methods: {
      /**
       * @param {Date} date
       * @return {String}
       */
      formatDate: function (date) {
        try {
          return moment(date).format('YYYY-MM-DD')
        } catch (error) {
          return date
        }
      }
    }
  }
</script>

<style scoped>
  .dynamic-double-column {
    column-count: 2;
    column-gap: 40px;
    column-width: inherit;
  }
  .table {
    table-layout: fixed;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/BestPractice/BestPracticeDataSheet.vue